// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import Paragraph from "components/typography/Paragraph";
import Block from "components/layout/Block";
import { NewsItem } from "./NewsItem";
import Link from "components/layout/Link";

// #####################################################

export const NewsSection = () => {
	const landingNews = useSelector((state) => state.landing.data.news);

	// #####################################################

	return (
		<Block mt={12}>
			<Link underline to={"/news"} color="primary">
				<Paragraph size="1.5rem" textCenter bold mb={4}>
					Nowości
				</Paragraph>
			</Link>

			{landingNews.map((item) => {
				return (
					<NewsItem
						key={item.id}
						id={item.id}
						url={`/news/${item.id}/${item.name_url}`}
						content={item.description}
						heading={item.name}
						date={item.date}
					/>
				);
			})}
		</Block>
	);
};

// #####################################################
